import { Email } from "@/Common/Api/Contacts/Dto/Email";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { ContactPointType } from "@/Common/Models/Contacts/Enums/ContactPointType";
import { EmployeeType } from "@/Common/Models/Employee/Enums/EmployeeType";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { Dispatcher } from "@/Common/Stores/Dispatcher";

interface IUserDemographicInfoComponentProps {
    transitionClass?: string;
    employeeModel: EmployeeUIModel;
    inProgress: boolean;
}

class UserDemographicInfoComponentState {
    public employeeResult: EmployeeUIModel;
}

class UserDemographicInfoComponent extends React.Component<IUserDemographicInfoComponentProps, UserDemographicInfoComponentState> {
    private c1Paddingtop: React.CSSProperties = { paddingTop: "5px", width: "190px" };

    constructor(props: IUserDemographicInfoComponentProps) {
        super(props);

        const initialState = new UserDemographicInfoComponentState();
        initialState.employeeResult = props.employeeModel;
        this.state = initialState;
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public componentDidUpdate(prevProps: IUserDemographicInfoComponentProps): void {
        const currentResult = this.props.employeeModel;
        const previousResult = prevProps.employeeModel;

        if (currentResult !== previousResult || this.props.inProgress !== prevProps.inProgress) {
            this.setState({
                employeeResult: currentResult
            });
        }
    }

    public render(): JSX.Element {
        return (
            <div className="user-component" data-cy="userProfile-demographicsView">
                <div className="flex-container heading" style={{ "borderBottom": "solid 1px #ccc", "margin": "20px 25px" }}>
                    <div className="h">
                        <h3 className="thin-font">{cacheStore.GetString("UserInformationLabel")}</h3>
                    </div>
                </div>
                <div className="patient-profile fxd-wdth-container">
                    <div className="tb">
                        {this.leftSide(this.state.employeeResult.Model)}
                        {this.rightSide(this.state.employeeResult.Model)}
                    </div>
                </div>

            </div>
        );
    }

    private leftSide(employee: Employee): JSX.Element {
        return (
            <div className="tbc left">
                <div>
                    <table>
                        <tbody>
                            {employee.Type !== EmployeeType.Api && (
                                <tr>
                                    <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PrefixLabel")}</label></td>
                                    <td className="c2" data-cy="userProfile-demographicsViewPrefix"><strong>{(employee.PrefixLookupId) ? (MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(employee.PrefixLookupId))) : "--"}</strong></td>
                                </tr>
                            )}
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("FirstNameLabel")}</label></td>
                                <td className="c2" data-cy="userProfile-demographicsViewFirstName"><strong>{MyleHelper.ReplaceEmptyString(employee.FirstName)}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("LastNameLabel")}</label></td>
                                <td className="c2" data-cy="userProfile-demographicsViewLastName"><strong>{MyleHelper.ReplaceEmptyString(employee.LastName)}</strong></td>
                            </tr>
                            {employee.Type !== EmployeeType.Api && (
                                <>
                                    <tr>
                                        <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("MiddleNameLabel")}</label></td>
                                        <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.MiddleName)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("SuffixLabel")}</label></td>
                                        <td className="c2"><strong>{(employee.SuffixLookupId) ? (MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(employee.SuffixLookupId))) : "--"}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("MaidenNameDLabel")}</label></td>
                                        <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.MaidenName)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("SecondNameLabel")}</label></td>
                                        <td className="c2"><strong>{MyleHelper.ReplaceEmptyString(employee.SecondName)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("SexLabel")}</label></td>
                                        <td className="c2" data-cy="userProfile-demographicsViewGender"><strong>{(employee.GenderLookupId) ? (MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(employee.GenderLookupId))) : "--"}</strong></td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private rightSide(employee: Employee): JSX.Element {
        if (employee.Type === EmployeeType.Api)
            return <div className="tbc right" />;

        let formattedPhone: string = "--";
        if (employee.Phones && employee.Phones.length > 0)
            formattedPhone = PhoneNumber.stringFormattedPhone(employee.Phones[0], true);

        return (
            <div className="tbc right">

                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PhoneLabel")}</label></td>
                                <td className="c2"><strong>{formattedPhone}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={{ "verticalAlign": "top", "width": "190px" }}><label className="form-label">{cacheStore.GetString("EmailLabel")}</label></td>
                                <td className="c2">
                                    {this.renderEmails(employee)}
                                </td>
                            </tr>
                            <tr>
                                <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top", "width": "190px" }}><label className="form-label">{cacheStore.GetString("ProfessionalDescriptionLabel")}</label></td>
                                <td className="c2" style={{ "paddingTop": "5px", "paddingRight": "30px" }}><strong>{MyleHelper.ReplaceEmptyString(employee.DescriptionProfessional)}</strong></td>
                            </tr>
                            {employee.Type === EmployeeType.Practician && (
                                <tr>
                                    <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top", "width": "190px" }}><label className="form-label" style={{ marginBottom: "0" }}>{cacheStore.GetString("OnlineFirstNameLabel")}</label></td>
                                    <td className="c2" style={{ "paddingTop": "5px", "paddingRight": "30px" }}><strong>{MyleHelper.ReplaceEmptyString(employee.OnlineFirstName)}</strong></td>
                                </tr>
                            )}
                            {employee.Type === EmployeeType.Practician && (
                                <tr>
                                    <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top", "width": "190px" }}><label className="form-label" style={{ marginBottom: "0" }}>{cacheStore.GetString("OnlineLastNameLabel")}</label></td>
                                    <td className="c2" style={{ "paddingTop": "5px", "paddingRight": "30px" }}><strong>{MyleHelper.ReplaceEmptyString(employee.OnlineLastName)}</strong></td>
                                </tr>
                            )}
                            {(employee.Type === EmployeeType.Practician) && (
                                <tr>
                                    <td className="c1" style={{ "paddingTop": "5px", "verticalAlign": "top", "width": "190px" }}><label className="form-label">{cacheStore.GetString("biographyLabel")}</label></td>
                                    <td className="c2" style={{ "paddingTop": "5px", "paddingRight": "30px" }}><strong>{(!IsNullOrWhiteSpace(employee.Biography)) ? JSXHelper.BreakStringIntoParagraphs(employee.Biography, true) : "--"}</strong></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    public renderEmails(employee: Employee): JSX.Element {
        const isNotified = employee.IsSendNotificationByEmail;
        let currentEmail = Email.newEmail(ContactPointType.Work);
        if (employee.Emails && employee.Emails.length > 0) {
            currentEmail = MyleHelper.CloneObject(employee.Emails[0]);
        }

        let emailsRender: JSX.Element[] = [];

        const displayResendEmailButton = !currentEmail.IsVerified && !cacheStore.ClinicSettings.EnableSSOAuthentication;

        if (!IsNullOrWhiteSpace(currentEmail.Address)) {
            let emailDetails = (
                <tbody key="addresses">
                    <tr>
                        <td>
                            <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                                <div>
                                    {currentEmail.IsVerified &&
                                        <span title={cacheStore.GetString("VerifiedLabel")} className="glyphicon glyphicon-ok green-text" style={{ marginRight: "5px" }} />
                                    }
                                    <strong><a href={"mailto:" + currentEmail.Address}>{MyleHelper.ReplaceEmptyString(currentEmail.Address)}</a></strong>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ paddingTop: "5px" }}>
                            <CheckboxControl
                                disabled={true}
                                id={"chkIsOk" + currentEmail.ContactPoint_id}
                                checked={currentEmail.IsOkToContact}
                                label={cacheStore.GetString("OkToContactLabel")}
                                item={currentEmail}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <CheckboxControl
                                checked={isNotified}
                                label={cacheStore.GetString("SendUpdateNotificationByEmailLabel")}
                                disabled={true}
                            />
                        </td>
                    </tr>

                    {displayResendEmailButton && (
                        <tr>
                            <td>
                                <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                                    <ButtonControl
                                        className="btn btn-primary"
                                        disabled={this.props.inProgress}
                                        onClick={() => this.resendEmail(currentEmail.Address, currentEmail.ContactPoint_id)}
                                        label={cacheStore.GetString("ResendVerificationCode")}
                                    />
                                </div>
                            </td>
                        </tr>
                    )}
                </tbody>
            );

            emailsRender.push(emailDetails);
        }
        else {
            var noEmails: JSX.Element = (
                <tbody key="email">
                    <tr>
                        <td className="c1" style={{ textAlign: "left" }}><span><strong>--</strong></span></td>
                        <td className="c2" />
                    </tr>
                </tbody>
            );
            emailsRender.push(noEmails);
        }

        return (
            <div>
                <div className="block separated">
                    <div className="flex-container heading" />
                    <div className="email-address fxd-wdth-container edit">
                        <div className="tb">
                            <div className="tbc left">
                                <div>
                                    <table>
                                        {emailsRender}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private resendEmail(emailAddress: string, contactPointId: string): void {
        const contactId = this.state.employeeResult.ContactId;
        const contactFacetId = this.state.employeeResult.ContactFacetId;
        const language = this.state.employeeResult.Model.Language;

        Dispatcher.dispatch(
            LocalOperations.AdministrationUsers.ResendEmailVerificationCode,
            {
                emailAddress,
                contactPointId,
                contactId,
                contactFacetId,
                language
            }
        );
    }
}

export { UserDemographicInfoComponent };
